import { useMemo } from 'react';
import './FloatingLeaves.css';

export default function FloatingLeaves({ count = 8 }) {
  const leaves = useMemo(() => {
    return Array.from({ length: count }).map((_, i) => {
      const left = Math.random() * 100;
      const delay = Math.random() * 18;
      const duration = 18 + Math.random() * 14;
      const size = 36 + Math.random() * 48;
      const rotate = Math.floor(Math.random() * 360);
      const mirror = i % 2 === 0;
      return { id: i, left, delay, duration, size, rotate, mirror };
    });
  }, [count]);

  return (
    <div className="fl" aria-hidden="true">
      {leaves.map((l) => (
        <img
          key={l.id}
          className="fl__leaf"
          src={l.mirror ? '/decor/banana-leaf-mirror.svg' : '/decor/banana-leaf.svg'}
          alt=""
          style={{
            left: `${l.left}%`,
            width: `${l.size}px`,
            animationDelay: `-${l.delay}s`,
            animationDuration: `${l.duration}s`,
            transform: `rotate(${l.rotate}deg)`
          }}
        />
      ))}
    </div>
  );
}
